import { ACCOUNT_ADMIN, ACCOUNT_SECURITY, ADD_ACCOUNT, ADD_ELIGIBILITY, identifiers } from "./Constants";

export const isPortalNameDisabled = (portal, adminDisabledOperations, screenName, isBasePortal) => {
    if(!adminDisabledOperations){
        switch (screenName) {
            case ADD_ACCOUNT:
                return true;
            case ACCOUNT_SECURITY:
                return isBasePortal;
            case ADD_ELIGIBILITY:
                return isBasePortal || isTeir1Portal(portal);
            default:
                return false;
        }
    }
    switch(screenName){
        case ADD_ELIGIBILITY:
            return adminDisabledOperations.addEligibility;
        case ACCOUNT_ADMIN:
            return adminDisabledOperations.accountAdmin
        case ADD_ACCOUNT:
            return true;
        default:
            return false;
    }
}

const isTeir1Portal = (portal) => {
    const isTeir1 = portal.uiConfig?.features?.accountType === 'TIER1';
    if (!isTeir1)
        return false;
    const uiIdentificationType = portal.uiConfig?.uiIdentificationTypes;
    if (!uiIdentificationType)
        return true;
    let isDisabled = true;
    uiIdentificationType.forEach(ui => {
        const elements = ui.elements;
        if (elements && elements.length >= 1){
            elements.forEach(ele => {
                if (identifiers.has(ele.id)) {
                    isDisabled = false;
                }
            });
        }
    });
    return isDisabled;
}